import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faChevronRight, faChevronLeft } from '@fortawesome/free-solid-svg-icons';

import { getLabel, setImgSrcSize, validateTextSize } from '../../utils';
import VCarouselHolder from './VCarouselStyles';

class VCarousel extends React.Component {
	state = {pagToRotate: [], index: 0, selected: []}

	componentDidMount() {
		const chunkSize = this.props.details.pageSize;
        const groups = _.chunk(this.props.items, chunkSize);
		this.setState({pagToRotate:groups, selected:groups[0]});
	}

	componentDidUpdate(prevProps) {
		if (prevProps.current_lang !== this.props.current_lang) {
			setTimeout(()=>{
				const chunkSize = this.props.details.pageSize;
				const groups = _.chunk(this.props.items, chunkSize);
				this.setState({pagToRotate:groups, selected:groups[0]});
			},1000);
		}
	}

	showPrev = () => {
		this.setState(prevState => {
			const newIndex = prevState.index ? prevState.index - 1 : 0;
			return {
			  index: newIndex,
			  selected: this.state.pagToRotate[newIndex]
			};
		});
	}

	showNext = () => {
		this.setState(prevState => {
			const newIndex = prevState.index < this.state.pagToRotate.length - 1 ? prevState.index + 1 : 0;
			return {
			  index: newIndex,
			  selected: this.state.pagToRotate[newIndex]
			};
		});
	}

	renderItems = () =>{
		return this.state.selected.map((item,i)=> {
			return (
				<li key={`v-items-grp-${i}`} itemProp='itemListElement'>
					<ReactCSSTransitionGroup
						transitionName="fade"
						transitionEnterTimeout={ 500 }
						transitionLeaveTimeout={ 300}
						transitionAppear={true}
						transitionAppearTimeout={2000}>
						<div className="latest-container__item"> 
							<a href={item.url} className="latest-container__item__img">
								<img src={setImgSrcSize(item.image,"sm")} alt={item.alt_image ? item.alt_image : item.title} itemProp='image'/>	
								{item.videoDuration && <div className="latest-container__item__img__date-container" aria-hidden="true">
									{item.videoDuration}
								</div>}
							</a>
							<div className="latest-container__item__info">
								<a href={item.categoryURL} className="latest-container__item__info__category" itemProp='subjectOf'>{item.category}</a>
								<a href={item.url} className="latest-container__item__info__title" itemProp='description'>
									{ item.title && validateTextSize(item.title, 88) }
									{ item.title && item.title.length > 88 && (
										<span className="description__ellipsis">...</span>
									)}
								</a>
							</div>
						</div>
					</ReactCSSTransitionGroup>
				</li>
			)
		})
	}
	
	render () {
		return (
			<VCarouselHolder>
				<div tabIndex="0" aria-label={this.props.details.title}>
					<h2 itemProp='name'>{this.props.details.title}</h2>
					<a className={`${this.props.details.paginated === "true" && this.props.details.seeallbtn ? "seeAllTopBtn" : "hidden"}`} href={this.props.details.seeAllUrl}>
						{getLabel("VIEW_ALL")}
						<FontAwesomeIcon icon={ faArrowRight }/>
					</a>
					<ul className="latest-container" itemScope itemType='https://schema.org/ItemList'>
						{this.state.selected && this.state.selected.length > 0 && this.renderItems()}
					</ul>
					{this.props.details.paginated === "false" && this.props.details.seeallbtn && <div className="latest-container__btns-container">
						<a href={this.props.details.seeAllUrl} className="seeAll-btn">
							{getLabel("SEEALL")}
						</a></div>}
					{this.props.details.paginated === "true" && <div className={`${this.props.details.paginated && this.props.items.length > this.props.details.pageSize ? "latest-container__btns-container" : "hidden"}`}>
							<button disabled={this.state.index === 0} onClick={this.showPrev}>
								<FontAwesomeIcon aria-hidden="true" icon={faChevronLeft} title='previous' />
								{getLabel("PREVIOUS")}
							</button>
							<button disabled={this.state.index === this.state.pagToRotate.length -1} onClick={this.showNext}>
								{getLabel("NEXT")}
								<FontAwesomeIcon aria-hidden="true" icon={faChevronRight} title='next' />
							</button>
					</div>}
				</div>
			</VCarouselHolder>
		)
	}
}

const mapStateToProps = (store) => ({
    current_lang: store.language.current,
});

export default connect(mapStateToProps,null)(VCarousel);